module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(_vm.explainer) ? _c('div', {
    staticClass: "explainer"
  }, [_vm._v("The Under Construction Club is a bunch of half-finished, undesigned projects released too early. Click the button for more info on this page or head to the site itself by clicking the name.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "topBanner"
  }, [_c('div', {
    staticClass: "bannerOverlay"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "http://www.under-construction.club"
    },
    on: {
      "mouseenter": function($event) {
        _vm.explainer = true
      },
      "mouseleave": function($event) {
        _vm.explainer = false
      }
    }
  }, [_vm._v("\n          Under Construction Club\n        ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.min = !_vm.min
      }
    }
  }, [(_vm.min) ? _c('span', [_vm._v("+")]) : _c('span', [_vm._v("-")])])])])]), _vm._v(" "), (!_vm.min) ? _c('div', {
    staticClass: "textBox"
  }, [(_vm.state === 'text') ? _c('div', [_c('button', {
    on: {
      "click": function($event) {
        _vm.state = 'guestbook'
      }
    }
  }, [_vm._v("Guestbook")]), _vm._v(" "), (_vm.config.about) ? _c('div', [_c('label', [_vm._v("About")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.config.about))])]) : _vm._e(), _vm._v(" "), (_vm.config.instructions) ? _c('div', [_c('label', [_vm._v("Instructions")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.config.instructions))])]) : _vm._e(), _vm._v(" "), (_vm.config.next) ? _c('div', [_c('label', [_vm._v("How Can I help?")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.config.next))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.state === 'guestbook') ? _c('div', [_c('button', {
    on: {
      "click": function($event) {
        _vm.state = 'text'
      }
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newComment),
      expression: "newComment"
    }],
    domProps: {
      "value": (_vm.newComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newComment = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": !_vm.newComment
    },
    on: {
      "click": _vm.post
    }
  }, [_vm._v("Post")]), _vm._v(" "), (_vm.comments) ? _c('div', [_c('label', [_vm._v("Suggestion Box/Guestbook")]), _vm._v(" "), _vm._l((_vm.comments), function(comment) {
    return _c('p', [_vm._v(_vm._s(comment.text))])
  })], 2) : _vm._e()]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d9aea9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/u3c/u3c.vue
// module id = 276
// module chunks = 1